import React from "react";
import logo from "../assets/image/logo .png"; 
import "font-awesome/css/font-awesome.min.css"

const Footer = () => (
  <footer
    style={{
      backgroundColor: "#222",
      color: "#fff",
      padding: "40px 20px",
      textAlign: "center",
      fontSize: "14px",
      position: "relative",
      bottom: "0",
      width: "100%",
      boxShadow: "0 -4px 10px rgba(0, 0, 0, 0.1)",
      borderTop: "2px solid #333",
    }}
  >
   
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "30px",
        flexWrap: "wrap",
        marginBottom: "40px",
      }}
    >
      {/* Logo Section */}
      <div style={{ flex: "1", maxWidth: "250px", textAlign: "left" }}>
        <img
          src={logo}  // Use the imported logo image
          alt="Atlas Trade Center Logo"
          style={{
            width: "150px",
            marginBottom: "15px",
            borderRadius: "8px",
          }}
        />
        <p style={{ color: "#bbb", marginBottom: "20px" }}>
          Your trusted partner in business solutions. We empower industries and businesses across Sri Lanka to succeed globally with top-tier products and services.
        </p>
      </div>

      {/* Quick Links */}
      <div style={{ flex: "1", maxWidth: "250px", textAlign: "left" }}>
        <h3 style={{ color: "#fff", marginBottom: "20px" }}>Quick Links</h3>
        <ul
          style={{
            listStyle: "none",
            padding: "0",
            fontSize: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "flex-start",
          }}
        >
          <li>
            <a
              href="/"
              style={{
                color: "#fff",
                textDecoration: "none",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#007bff")}
              onMouseLeave={(e) => (e.target.style.color = "#fff")}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="/about"
              style={{
                color: "#fff",
                textDecoration: "none",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#007bff")}
              onMouseLeave={(e) => (e.target.style.color = "#fff")}
            >
              About Us
            </a>
          </li>
          <li>
            <a
              href="/shop"
              style={{
                color: "#fff",
                textDecoration: "none",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#007bff")}
              onMouseLeave={(e) => (e.target.style.color = "#fff")}
            >
              Shop
            </a>
          </li>
          <li>
            <a
              href="/contact"
              style={{
                color: "#fff",
                textDecoration: "none",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#007bff")}
              onMouseLeave={(e) => (e.target.style.color = "#fff")}
            >
              Contact Us
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Information */}
      <div style={{ flex: "1", maxWidth: "250px", textAlign: "left" }}>
        <h3 style={{ color: "#fff", marginBottom: "20px" }}>Contact Information</h3>
        <p style={{ color: "#bbb", marginBottom: "5px" }}>
          <strong>Email:</strong> <a href="mailto:info@atlastradecenter.lk" style={{ color: "#fff" }}>info@atlastradecenter.lk</a>
        </p>
        <p style={{ color: "#bbb", marginBottom: "5px" }}>
          <strong>Phone:</strong> +94 11 2 399399
        </p>
        <p style={{ color: "#bbb", marginBottom: "5px" }}>
          <strong>Address:</strong> No: 17, H K Dharmadasa Mawatha, Colombo 02, Sri Lanka
        </p>
      </div>

      {/* Social Media */}
      <div style={{ flex: "1", maxWidth: "250px", textAlign: "left" }}>
        <h3 style={{ color: "#fff", marginBottom: "20px" }}>Follow Us</h3>
        <div>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              margin: "0 15px",
              fontSize: "20px",
              color: "#fff",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#3b5998")}
            onMouseLeave={(e) => (e.target.style.color = "#fff")}
          >
            <i className="fa fa-facebook"></i>
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              margin: "0 15px",
              fontSize: "20px",
              color: "#fff",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#00acee")}
            onMouseLeave={(e) => (e.target.style.color = "#fff")}
          >
            <i className="fa fa-twitter"></i>
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              margin: "0 15px",
              fontSize: "20px",
              color: "#fff",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#e1306c")}
            onMouseLeave={(e) => (e.target.style.color = "#fff")}
          >
            <i className="fa fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>

    {/* Footer Bottom Section */}
    <div
      style={{
        fontSize: "14px",
        color: "#bbb",
        marginTop: "40px",
        borderTop: "1px solid #444",
        paddingTop: "20px",
      }}
    >
      <p>© 2024 Atlas Trade Center | All Rights Reserved</p>
      <p>Designed by SLT Digital Service</p>
    </div>
  </footer>
);

export default Footer;
